{
  "belugas.ax-admin-export-rovo-usage.message-template-template.email.header.logo.alt": [
    {
      "type": 0,
      "value": "Atlassian"
    }
  ],
  "belugas.ax-admin-export-rovo-usage.message-template.email.footer.text": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Administration."
    }
  ],
  "belugas.ax-admin-export-rovo-usage.message-template.email.header.contact-support.button": [
    {
      "type": 0,
      "value": "Contact support"
    }
  ],
  "belugas.ax-admin-export-rovo-usage.message-template.email.header.download.button": [
    {
      "type": 0,
      "value": "Download CSV file"
    }
  ],
  "belugas.ax-admin-export-rovo-usage.message-template.email.header.download.intro": [
    {
      "type": 0,
      "value": "A CSV of your organization’s Rovo usage is ready to download."
    }
  ],
  "belugas.ax-admin-export-rovo-usage.message-template.email.header.download.intro.access": [
    {
      "type": 0,
      "value": "Only organization admins can access this link and it expires in 24 hours."
    }
  ],
  "belugas.ax-admin-export-rovo-usage.message-template.email.header.download.intro.contact": [
    {
      "type": 0,
      "value": "If you need access to more data, contact support to request a larger export."
    }
  ],
  "belugas.ax-admin-export-rovo-usage.message-template.email.header.download.title": [
    {
      "type": 0,
      "value": "Download usage data export"
    }
  ],
  "belugas.ax-admin-export-rovo-usage.message-template.email.office-icon.alt": [
    {
      "type": 0,
      "value": "Organization"
    }
  ],
  "belugas.ax-admin-export-rovo-usage.message-template.email.subject": [
    {
      "type": 0,
      "value": "Your user export is ready"
    }
  ],
  "belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.branded-header.description": [
    {
      "type": 0,
      "value": "Atlassian Rovo logo"
    }
  ],
  "belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.cta-button": [
    {
      "type": 0,
      "value": "Unlock all of Rovo's potential"
    }
  ],
  "belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.footer.address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.heading": [
    {
      "type": 0,
      "value": "You're almost there!"
    }
  ],
  "belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.hero-image.description": [
    {
      "type": 0,
      "value": "People collaborating with Rovo, showing various app integrations including Google Drive, Gmail, GitHub, Slack, and others"
    }
  ],
  "belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.body.supporting-text": [
    {
      "type": 0,
      "value": "Rovo is nearly ready. Connect your apps to enable all the features for your organization."
    }
  ],
  "belugas.belugas-rovo-onboarding-completion-reminder.message-template.email.subject": [
    {
      "type": 0,
      "value": "Reminder: Finish setting up Rovo by connecting your apps"
    }
  ],
  "belugas.rovo-enablement-notification.message-template.email.body.branded-header.description": [
    {
      "type": 0,
      "value": "Atlassian Rovo logo"
    }
  ],
  "belugas.rovo-enablement-notification.message-template.email.body.cta-button": [
    {
      "type": 0,
      "value": "Connect my apps"
    }
  ],
  "belugas.rovo-enablement-notification.message-template.email.body.footer.address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "belugas.rovo-enablement-notification.message-template.email.body.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "belugas.rovo-enablement-notification.message-template.email.body.heading": [
    {
      "type": 0,
      "value": "Rovo is ready. Connect your apps today."
    }
  ],
  "belugas.rovo-enablement-notification.message-template.email.body.hero-image.description": [
    {
      "type": 0,
      "value": "People collaborating with Rovo, showing various app integrations including Google Drive, Gmail, GitHub, Slack, and others"
    }
  ],
  "belugas.rovo-enablement-notification.message-template.email.body.supporting-text": [
    {
      "type": 0,
      "value": "Power up your workspace. Set up and configure connectors to unlock all Rovo's potential."
    }
  ],
  "belugas.rovo-enablement-notification.message-template.email.subject": [
    {
      "type": 0,
      "value": "Rovo is ready for you to set up"
    }
  ],
  "post-office.confluence-rovo-onboarding-banner.body": [
    {
      "type": 0,
      "value": "Power up your workspace. Set up and configure connectors to unlock all Rovo's potential."
    }
  ],
  "post-office.confluence-rovo-onboarding-banner.call.to.action": [
    {
      "type": 0,
      "value": "Get started"
    }
  ],
  "post-office.confluence-rovo-onboarding-banner.heading": [
    {
      "type": 0,
      "value": "Rovo is ready for you"
    }
  ],
  "post-office.confluence-rovo-onboarding-banner.why-am-i-seeing-this.message": [
    {
      "type": 0,
      "value": "We think setting up Rovo and connecting apps will improve your team's productivity. You're seeing this because Rovo is available to your team, and as an organizational admin you can extend Rovo's features by configuring connectors."
    }
  ],
  "post-office.confluence-rovo-onboarding-banner.why-am-i-seeing-this.reason": [
    {
      "type": 0,
      "value": "Rovo is available to your team and you are an organizational admin"
    }
  ]
}